import { useEffect, useRef, useState } from 'react';

export const useDebounceValue = <T>(value: T, delay: number): T => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => clearTimeout(handler);
  }, [value, delay]);

  return debouncedValue;
};

export const useDebounce = () => {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const debounce = <T extends (...args: unknown[]) => void>(
    callback: T,
    delay: number
  ) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      callback();
    }, delay);
  };

  return debounce;
};
